var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.formValid,
                    callback: function ($$v) {
                      _vm.formValid = $$v
                    },
                    expression: "formValid",
                  },
                },
                [
                  _c(
                    "base-card",
                    [
                      _c("v-card-title", [
                        _vm._v("Configuración Tiempo Inactividad"),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "3" } },
                                [
                                  _c("v-text-field", {
                                    ref: "Time",
                                    attrs: {
                                      label: "Tiempo Inactividad (Horas)",
                                      "prepend-inner-icon": "mdi-clock-outline",
                                      type: "number",
                                      clearable: "",
                                      required: "",
                                      rules: _vm.emisorFormRules,
                                    },
                                    on: { change: _vm.validateInput },
                                    model: {
                                      value: _vm.dataCredentials.client,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataCredentials,
                                          "client",
                                          $$v
                                        )
                                      },
                                      expression: "dataCredentials.client",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "4" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-2",
                                      staticStyle: {
                                        "background-color": "rgb(204 33 40)",
                                        color: "white !important",
                                      },
                                      attrs: { disabled: !_vm.formValid },
                                      on: { click: _vm.sendHours },
                                    },
                                    [_vm._v(" Registrar tiempo ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: "3000", top: "", color: "success" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }